import { initEventOrganisationDataStorage } from '../../../packages/src/eventOrganisationDataStorage.js';

const eventOrganisationDataStorage = initEventOrganisationDataStorage();
const STORIBOX_WEBAPP_FOOTER_URLS = ['https://storibox.com/webapps/', 'https://east.storibox.com/webapps/'];

function normalizeWebappDomain(value) {
  if (!value || typeof value !== 'string') {
    return '';
  }

  try {
    const u = new URL(value.trim());
    const path = u.pathname.replace(/\/+$/, '');
    return `${u.origin}${path}`.toLowerCase();
  } catch {
    return '';
  }
}

function isStoriboxWebappsFooterDomain() {
  const stored = normalizeWebappDomain(eventOrganisationDataStorage.getWebappDomainFromStorage());
  if (!stored) {
    return false;
  }
  return STORIBOX_WEBAPP_FOOTER_URLS.some((url) => normalizeWebappDomain(url) === stored);
}

function createLegalLinks() {
  const nav = document.createElement('nav');
  nav.className = 'storibox-footer__links';
  nav.setAttribute('aria-label', 'Legal links');

  const privacy = document.createElement('a');
  privacy.className = 'storibox-footer__link';
  privacy.textContent = 'Privacy Policy';
  privacy.href = 'https://storibox.com/privacy.html';
  privacy.target = '_blank';
  privacy.rel = 'noopener noreferrer';

  const terms = document.createElement('a');
  terms.className = 'storibox-footer__link';
  terms.textContent = 'Terms of Use';
  terms.href = 'https://storibox.com/terms.html';
  terms.target = '_blank';
  terms.rel = 'noopener noreferrer';

  nav.append(privacy, terms);
  return nav;
}

function createFooter({ isRegistrationPage = false } = {}) {
  const footer = document.createElement('footer');
  footer.className = 'storibox-footer';

  const logo = document.createElement('img');
  logo.className = 'storibox-footer__logo';
  logo.src = 'img/logo-rgb.png';
  logo.alt = 'Storibox';

  footer.append(logo, createLegalLinks());

  if (isRegistrationPage) {
    footer.classList.add('storibox-footer_reg-page');
  }

  return footer;
}

function mountStoriboxFooter(options) {
  if (!document.body || document.querySelector('.storibox-footer') || !isStoriboxWebappsFooterDomain()) {
    return;
  }

  document.body.classList.add('body_has-storibox-footer');
  document.body.append(createFooter(options));
}

export function initStoriboxFooter(options) {
  if (document.readyState !== 'loading') {
    mountStoriboxFooter(options);
    return;
  }
  document.addEventListener('DOMContentLoaded', () => mountStoriboxFooter(options), { once: true });
}
